var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":_vm.capitalize(_vm.$t('status'))}},[_c('vue-apex-charts',{attrs:{"options":_vm.chartOptions,"series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }